<template>
  <div>
    <card class="card-user">
      <div slot="image">
        <img src="../../../assets/img/sidebar_img_vl.jpg" alt="..." />
      </div>
      <div v-if="showDeleteUser" class="card__deleteButton">
        <p-button type="danger" icon outline @click.native.prevent="openDelete = true">
          <i class="fas fa-trash" />
        </p-button>
      </div>
      <div>
        <div class="author">
          <div v-if="files.length > 0">
            <label for="avatar">
              <img class="avatar border-white cursor-pointer" :src="files[0].url" alt="" />
              <i class="fas fa-cloud-upload-alt avatar__upload"></i>
            </label>
          </div>
          <div v-else>
            <div v-if="userCopy.avatar">
              <label for="avatar" class="avatar border-white">
                <img class="avatar__img cursor-pointer" :src="userCopy.avatar" alt="..." />
                <i class="fas fa-cloud-upload-alt avatar__upload"></i>
              </label>
            </div>
            <div v-else>
              <label for="avatar" class="avatar border-white">
                <img class="avatar__img cursor-pointer" src="../../../assets/img/user_circle.jpeg" alt="..." />
                <i class="fas fa-cloud-upload-alt avatar__upload"></i>
              </label>
            </div>
          </div>

          <file-upload
            extensions="jpg,jpeg,png"
            accept="image/*"
            :multiple="false"
            name="avatar"
            :custom-action="uploadFile"
            :drop="true"
            v-model="files"
            @input-filter="inputFilter"
            @input-file="inputFile"
            ref="upload"
          >
          </file-upload>

          <div class="avatar-upload">
            <div v-if="$refs.upload && $refs.upload.dropActive">
              <i class="fas fa-cloud-upload-alt"></i>
              <h3>Drop img to upload</h3>
            </div>
            <div v-if="fileAttached">
              <p-button class="mr-2" type="danger" @click.native.prevent="remove(files)"> Remove </p-button>
              <p-button type="success" :loading="loadingSave" @click.native.prevent="$refs.upload.active = true">
                Upload
              </p-button>
            </div>
          </div>
          <h4 class="title">
            {{ userCopy.first_name }} {{ userCopy.last_name }}
            <div v-for="(role, index) in user.roles" v-bind:key="index">
              <small>#{{ role.data.name }}</small>
            </div>
          </h4>
        </div>
        <p class="description text-center">
          {{ userCopy.company.data.name }}
        </p>
      </div>
      <hr />
    </card>

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      action="deleteUser"
      :clicked="openDelete"
      :data="{
        deletion_object_name: user_full_name,
        deletion_object_text: $t('this_user'),
        delete_button_title: $t('delete_user'),
        header: $t('delete_user'),
      }"
      :button_data="{
        title: $t('delete_this_user'),
      }"
      @submit="deleteUser()"
      @update:field="openDelete = false"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
import axiosAuth from '../../../axiosMain';
import UsersController from '@/controllers/Users/UsersController';

export default {
  components: { ModalTemplate },
  props: {
    user: {
      type: Object,
    },
    showDeleteUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userCopy: null,
      details: [
        {
          title: '12h',
          subTitle: 'Last Week',
        },
        {
          title: '86',
          subTitle: 'Leaves',
        },
        {
          title: 'Turquoise',
          subTitle: 'status',
        },
      ],
      openDelete: false,
      user_full_name: '',
      files: [],
      fileAttached: false,
      loadingSave: false,
    };
  },
  computed: {
    auth_user() {
      return this.$store.getters.user;
    },
  },
  async mounted() {
    await this.setUser();
  },
  methods: {
    setUser: async function () {
      this.userCopy = this.user;
      this.user_full_name = this.user.first_name + ' ' + this.user.last_name;
    },
    deleteUser: function () {
      axiosAuth
        .delete('/users/' + this.user.user_id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.$router.push('/companies/' + this.auth_user.company.data.company_id);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_user_was_deleted'),
          });
        })
        .catch((errors) => {});
    },
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-lg-3 offset-lg-1';
      } else if (remainder === 2) {
        return 'col-lg-4';
      } else {
        return 'col-lg-3';
      }
    },
    async uploadFile(file) {
      try {
        this.loadingSave = true;
        this.userCopy = await UsersController.update(this.user.user_id, { avatar_url: this.files[0].file });
        this.remove(this.files);
        this.$store.dispatch('fetchAuthUser');
        this.$notify({
          type: 'success',
          title: 'New avatar was saved',
        });
        this.loadingSave = false;
      } catch (error) {
        this.loadingUpload = false;
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },

    remove(files) {
      let vm = this;
      files.forEach((file) => {
        vm.$refs.upload.remove(file);
      });
      this.fileAttached = false;
    },

    inputFile() {
      this.fileAttached = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpg|jpeg|png)$/i.test(newFile.name)) {
          this.alert('Format of your file is invalid');
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    alert(message) {
      alert(message);
    },
  },
};
</script>
<style>
.userProfile-icon {
  font-size: 6rem;
}
.select_file {
  position: absolute;
  left: 0;
}
</style>
